import React from 'react';
import Button from 'material-ui/Button';
//import { ValidatorForm } from 'react-form-validator-core';
import { TextValidator,SelectValidator, ValidatorForm} from 'react-material-ui-form-validator';
import {FormControl,FormGroup,FormControlLabel,} from 'material-ui/Form';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';

import $ from 'jquery';
import LINK from '../constants/LinkConstants.js';


class MyForm extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
          user: {},gradeLevelId:"",
      };
      this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
      // custom rule will have name 'isPasswordMatch'
      ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
          if (value !== this.state.user.password) {
              return false;
          }
          return true;
      });
  }

  handleChange(event) {
      const { user } = this.state;
      user[event.target.name] = event.target.value;
      this.setState({ user });
  }

  handleSelect =name=> event=> {
    this.setState({ [name]: event.target.value });
  }

  handleSubmit() {
      // your submit logic
      $.ajax({
       url: LINK.BASE_URL,
       cache: false,
       type : 'GET',
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
       },
       success: function(response) {
         console.log(response);
       }.bind(this),
       error: function(xhr, status, err) {
         alert(err)
       }.bind(this)
      });

  }

  render() {
      const { user } = this.state;
      const Label = () => <InputLabel>Select your grade range</InputLabel>;


      return (
          <ValidatorForm
              onSubmit={this.handleSubmit}
          >
              <TextValidator
                  floatingLabelText="Password"
                  onChange={this.handleChange}
                  name="password"
                  type="password"
                  validators={['required']}
                  errorMessages={['this field is required']}
                  value={user.password}
              />
              <TextValidator
                  floatingLabelText="Repeat password"
                  onChange={this.handleChange}
                  name="repeatPassword"
                  type="password"
                  validators={['isPasswordMatch', 'required']}
                  errorMessages={['password mismatch', 'this field is required']}
                  value={user.repeatPassword}
              />
              <SelectValidator name="gradeLevelId" style={{width:"200px"}}
                    value={this.state.gradeLevelId}
                    onChange={this.handleSelect('gradeLevelId')}
                    validators={['required']}
                    errorMessages={['required field']}
                    formControl={FormControl}
                    inputLabel={Label}
                >
                <MenuItem value="Please Choose">
                  <em>Please Choose</em>
                </MenuItem>
                <MenuItem value="Yes">
                  Yes
                </MenuItem>
                <MenuItem value="No">
                  No
                </MenuItem>
                </SelectValidator>
              <Button type="submit" />
          </ValidatorForm>
      );
  }
}

export default MyForm;



// WEBPACK FOOTER //
// ./src/components/form.js